var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4003 2.2793H6.60027C5.45454 2.2793 4.35573 2.73444 3.54557 3.5446C2.73542 4.35475 2.28027 5.45356 2.28027 6.5993V17.3993C2.28027 17.9666 2.39201 18.5284 2.60911 19.0525C2.82621 19.5766 3.14442 20.0529 3.54557 20.454C4.35573 21.2642 5.45454 21.7193 6.60027 21.7193H17.4003C17.9676 21.7193 18.5293 21.6076 19.0535 21.3905C19.5776 21.1734 20.0538 20.8552 20.455 20.454C20.8561 20.0529 21.1743 19.5766 21.3914 19.0525C21.6085 18.5284 21.7203 17.9666 21.7203 17.3993V6.5993C21.7203 6.03199 21.6085 5.47023 21.3914 4.9461C21.1743 4.42198 20.8561 3.94574 20.455 3.5446C20.0538 3.14345 19.5776 2.82524 19.0535 2.60814C18.5293 2.39104 17.9676 2.2793 17.4003 2.2793Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.67969V16.3197",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67969 12H16.3197",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPlus);
export default __webpack_public_path__ + "static/media/add-plus.37f7b2e752256d6d7b46def0e23e496f.svg";
export { ForwardRef as ReactComponent };